module.exports = __webpack_public_path__ + "img/icon_hd.1a5fe7d3.png";